(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["toy-background-animation"] && !Shopify.designMode) return;
  try {
    class ToyBackground extends HTMLElement {
  constructor() {
    super();
    this.items = Array.from(this.querySelectorAll('.toy-bg__item'));
    this.pulseTargets = Array.from(this.querySelectorAll('.toy-bg__item-pulse'));

    if (!this.items.length) return;

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (this.reducedMotion.matches) return;

    this.ticking = false;
    this.pointerNX = 0;
    this.pointerNY = 0;
    this.hasPointer = false;

    this.onScroll = this.onScroll.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onInteractionPulse = this.onInteractionPulse.bind(this);
    this.update = this.update.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('pointermove', this.onPointerMove, { passive: true });
    window.addEventListener('pointerdown', this.onInteractionPulse, { passive: true });
    this.update();
  }

  requestUpdate() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(this.update);
  }

  onScroll() {
    this.requestUpdate();
  }

  onPointerMove(event) {
    if (event.pointerType === 'touch') return;
    this.hasPointer = true;
    this.pointerNX = (event.clientX / window.innerWidth - 0.5) * 2;
    this.pointerNY = (event.clientY / window.innerHeight - 0.5) * 2;
    this.requestUpdate();
  }

  onInteractionPulse() {
    this.pulseTargets.forEach((el, index) => {
      window.setTimeout(() => {
        el.classList.remove('is-pulsing');
        // Force reflow so the animation restarts if it's still running.
        void el.offsetWidth;
        el.classList.add('is-pulsing');
      }, index * 35);
    });
  }

  update() {
    const scrollY = window.scrollY || window.pageYOffset || 0;

    this.items.forEach((item, index) => {
      const speed = Number(item.dataset.toySpeed) || 0.5;
      const phase = index * 0.8;
      const scrollY_ = Math.sin(scrollY * 0.0025 * speed + phase) * 24;
      const scrollX_ = Math.cos(scrollY * 0.002 * speed + phase) * 14;
      const pointerX = this.hasPointer ? this.pointerNX * speed * 32 : 0;
      const pointerY = this.hasPointer ? this.pointerNY * speed * 22 : 0;
      const x = scrollX_ + pointerX;
      const y = scrollY_ + pointerY;
      item.style.transform = `translate(${x.toFixed(1)}px, ${y.toFixed(1)}px)`;
    });

    this.ticking = false;
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerdown', this.onInteractionPulse);
  }
}

if (!customElements.get('toy-background')) {
  customElements.define('toy-background', ToyBackground);
}
  } catch(e) { console.error(e); }
})();

})();
